﻿import React, { useState, useEffect } from 'react';
import { CrudFunctions } from '../utilities/crud-functions';
import { Entities, ModalMessageType } from '../models/enums';
import { RawMaterialAnalyticalPlan } from '../models/RawMaterials/raw-material-analytical-plan';
import { AnalyticalPlanEditObject } from '../models/analytical-plan-edit-object';
import RawMaterialAnalyticalPlanEditor from './RawMaterialAnalyticalPlanEditor';
import { AnalyticalPlansLookupData } from '../models/analytical-plans-lookup-data';
import AuditHistoryComponent from './AuditHistoryComponent';
import ItemBasicInformationDialog from './ItemBasicInformationDialog';
import { ItemBasicInformation } from '../models/item-basic-information';
import { ModalMetadata } from '../models/modal-metadata';
import GlobalDialog from './Modal/GlobalDialog';
import { ToastProps } from '../models/toast-props';

import DataGrid, {
    Column,
    Selection,
    Paging,
    Toolbar,
    Item as ToolbarItem,
    Button as ColumnButton
} from 'devextreme-react/data-grid';

import SelectBox from 'devextreme-react/select-box';
import { Popup as DialogPopup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';
import { Toast } from 'devextreme-react/toast';

let key = 0;

export interface Props {
    rawMaterialBatchId: string;
    isReadOnly: boolean;
}

export default function RawMaterialsAnalyticalPlansData(props: Props) {
    const [analyticalPlans, setAnalyticalPlans] =
        useState<RawMaterialAnalyticalPlan[]>();

    //const [analyticalPlanEditObject, setAnalyticalPlanEditObject] =
      //  useState<AnalyticalPlanEditObject>();

    const [selectedAnalyticalPlan, setSelectedAnalyticalPlan] =
        useState<RawMaterialAnalyticalPlan>();

    const [lookupData, setLookupData] =
        useState<AnalyticalPlansLookupData>();

    const [auditEntity, setAuditEntity] =
        useState<Entities>();

    const [auditRowPointer, setAuditRowPointer] =
        useState<string>();

    const [itemBasicInformation, setItemBasicInformation] =
        useState<ItemBasicInformation>();

    const [addTechnologyDialogVisible, setAddTechnologyDialogVisible] =
        useState<boolean>();

    const [addTechnologySelection, setAddTechnologySelection] =
        useState<number>();

    const [editAnalyticalPlanDialogVisible, setEditAnalyticalPlanDialogVisible] =
        useState<boolean>();

    const [auditInformationDialogVisible, setAuditInformationDialogVisible] =
        useState<boolean>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [toastProps, setToastProps] =
        useState<ToastProps>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, [props.rawMaterialBatchId]);

    ++key;
    
    return (
        <div>
            <DataGrid
                height='20rem'
                wordWrapEnabled={true}
                allowColumnResizing={true}
                keyExpr="analyticalPlanId"
                columnResizingMode="nextColumn"
                onSelectionChanged={onAnalyticalPlansSelectionChanged}
                dataSource={analyticalPlans ? analyticalPlans : []}
                rowAlternationEnabled={true}
                showRowLines={true}
                showBorders={true}>

                <Selection mode='single' />
                <Paging enabled={false} />

                <Column type="buttons" width='4.5rem' >
                    <ColumnButton hint="edit analytical plan" icon="edit"
                        onClick={showEditAnalyticalPlanDialogVisible} />
                    <ColumnButton hint="audit information" icon="clock"
                        onClick={onAnalyticalPlansAuditButtonClicked} />
                    <ColumnButton hint="information" icon="info"
                        onClick={onAnalyticalPlansInformationButtonClicked} />
                </Column>

                <Column dataField='technologyName' caption="Technology" width="8rem" dataType="string" />
                <Column dataField='analysisTypeNamesList' caption="Analysis Types" width="12rem" dataType="string" />
                <Column dataField='basisTypeNamesList' caption="Basis Types" width="12rem" dataType="string" />
                <Column dataField='description' width='20rem' dataType="string" />
                <Column dataField='specification' width='12rem' dataType="number" />
                <Column dataField='methodName' width='12rem' dataType="string" />
                <Column dataField='methodVersionNumber' caption="Version #" width='6rem' dataType="number" />
                <Column />

                <Toolbar>
                    <ToolbarItem location='before'>
                        <div className="pw-datagrid-toolbar-template">
                            <div className="pw-datagrid-toobar-title">Analytical Plan</div>
                        </div>
                    </ToolbarItem>

                    <ToolbarItem location='after'>
                        <Button type='success' width='1.8rem' icon='clock'
                            text=''
                            hint='Analytical Plan Audit Information'
                            onClick={showAnalyticalPlansAuditInformationDialog} />
                    </ToolbarItem>
                    <ToolbarItem location='after'>
                        <Button type='normal' width='1.8rem' icon='plus'
                            text=''
                            hint='Add technology to Analytical Plan'
                            onClick={addAnalyticalPlanTechnology} />
                    </ToolbarItem>
                </Toolbar>

            </DataGrid>

            {addTechnologyDialogVisible &&
                <DialogPopup visible={addTechnologyDialogVisible}
                    onHiding={hideAddTechnologyDialog}
                    title="Add Analytical Plan Technology"
                    width='30rem'
                    height='12rem'>
                    <div>
                        <div className="pw-form-unit">
                            <div className="pw-form-unit-label">Technology</div>
                            <SelectBox id="addTechnologyTechnologyTypesSelectBox" className="selectbox"
                                placeholder='NA'
                                displayExpr='name' valueExpr='id'
                                dataSource={lookupData && lookupData.technologyTypes ?
                                    lookupData.technologyTypes : []}
                                onValueChanged={onAddTechnologySelectionChanged}
                                value={addTechnologySelection ? addTechnologySelection : undefined} />
                        </div>
                        <div className="pw-comp-row">
                            <div className="pw-centered-buttons-container">
                                <Button id="applySelectionButton"
                                    className="pw-button"
                                    text="Apply" type="success"
                                    hint="apply selection"
                                    height='2.6em'
                                    onClick={onApplyAddedTechnologyClick} />

                                <Button id="cancelButton"
                                    className="pw-button"
                                    text="Cancel" type="normal"
                                    hint="cancel"
                                    height='2.6em'
                                    onClick={hideAddTechnologyDialog} />
                            </div>
                        </div>
                    </div>

                </DialogPopup>
            }

            {editAnalyticalPlanDialogVisible &&
                <DialogPopup visible={editAnalyticalPlanDialogVisible}
                    onHiding={hideEditAnalyticalPlanDialog}
                    title="Edit Analytical Plan"
                    fullScreen={true}
                    minWidth={'50em'}
                    minHeight={'32em'}
                    dragEnabled={true}
                    resizeEnabled={true}>
                    <RawMaterialAnalyticalPlanEditor rawMaterialBatchId={props.rawMaterialBatchId}
                        analyticalPlanId={selectedAnalyticalPlan && selectedAnalyticalPlan.analyticalPlanId ? 
                            selectedAnalyticalPlan.analyticalPlanId : undefined}
                        lookupData={lookupData}
                        key={`EAP${key}`} onClose={hideEditAnalyticalPlanDialog} />
                </DialogPopup>
            }            

            {auditInformationDialogVisible &&
                <DialogPopup visible={auditInformationDialogVisible}
                    onHiding={hideAuditInformationDialog}
                    title="Audit History"
                    minWidth={'50em'}
                    minHeight={'32em'}
                    dragEnabled={true}
                    resizeEnabled={true}>
                    <AuditHistoryComponent entityNumber={auditEntity}
                        key={`AuditHistory${key}`}
                        childData={false}
                        rowPointer={auditRowPointer ? auditRowPointer : undefined} />
                </DialogPopup>
            }

            {itemBasicInformationDialogVisible &&
                <DialogPopup visible={itemBasicInformationDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title="Item Basic Information"
                    width={'25rem'}
                    height={'21rem'}
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <ItemBasicInformationDialog initInformation={itemBasicInformation}
                        onOkClick={hideItemBasicInformationDialog}
                        key={`IBI${key}`} />
                </DialogPopup>
            }

            {toastProps && toastProps.visible &&
                <Toast
                    visible={toastProps.visible}
                    message={toastProps.message}
                    type={toastProps.toastType}
                    onHiding={onToastHiding}
                    displayTime={600} />
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    function onAnalyticalPlansSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            setSelectedAnalyticalPlan(e.selectedRowsData[0]);
        }
    }


    function addAnalyticalPlanTechnology() {
        setAddTechnologyDialogVisible(true);
    }

    function onAddTechnologySelectionChanged(e: any) {
        setAddTechnologySelection(e.value);
    }

    async function onApplyAddedTechnologyClick() {
        if (!addTechnologySelection)
            return;

        console.log(255);

        const newAnalyticalPlan: RawMaterialAnalyticalPlan = {
            rawMaterialBatchId: props.rawMaterialBatchId,
            analyticalTechnologyId: addTechnologySelection
        }

        console.log("newAnalyticalPlan:");
        console.log(newAnalyticalPlan);

        await insertAnalyticalPlan(newAnalyticalPlan)
            .then(() => {
                showToast("Analytical Plan Technology Added Successfully", "success");
                getProductAnalyticalPlan();
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Adding Analytical Plan technology");
            });

        setAddTechnologyDialogVisible(false);
    }

    function showEditAnalyticalPlanDialogVisible(e: any) {
        if (e.row && e.row.data) {
            setSelectedAnalyticalPlan(e.row.data);

            /*
            const editObject: AnalyticalPlanEditObject = {
                analyticalPlan: e.row.data,
                lookupData: lookupData
            };

            setAnalyticalPlanEditObject(editObject);
            */


            setEditAnalyticalPlanDialogVisible(true);
        }
    }

    async function analyticalPlanRemoving(e: any) {
        if (e.data && e.data.analyticalPlanId) {
            deleteAnalyticalPlan(e.data.analyticalPlanId)
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Deleting Analytical Plan");
                });
        }
    }

    async function getLookupData() {
        await CrudFunctions.getData("common/analyticalplanslookupdata")
            .then((data) => {
                setLookupData(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Lookup Data");
            });
    }

    async function getProductAnalyticalPlan() {
        await CrudFunctions.getData(`rawmaterials/analyticalplans/${props.rawMaterialBatchId}`)
            .then(data => {

                console.log(data);
                setAnalyticalPlans(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Analytical Plan");
            });
    }

    //POST functions

    async function insertAnalyticalPlan(analyticalPlan: RawMaterialAnalyticalPlan) {
        return CrudFunctions.postData("rawmaterials/analyticalplan", analyticalPlan);
    }

    // DELETE functions

    async function deleteAnalyticalPlan(analyticalPlanId: string) {
        return CrudFunctions.deleteData(`rawmaterials/analyticalplan/${analyticalPlanId}`);
    }

    function onAnalyticalPlansAuditButtonClicked(e: any) {
        if (e.row && e.row.data) {
            setAuditEntity(Entities.AnalyticalPlans);
            setAuditRowPointer(e.row.data.analyticalPlanId);
            setAuditInformationDialogVisible(true);
        }
    }

    function onAnalyticalPlansInformationButtonClicked(e: any) {
        if (e.row && e.row.data) {
            let itemInformation: ItemBasicInformation = {
                rowPointer: e.row.data.analyticalPlanId,
                createTimestamp: e.row.data.createTimestamp,
                lastModifiedTimestamp: e.row.data.modifyTimestamp,
                createUser: e.row.data.createUser,
                modifyUser: e.row.data.modifyUser
            };

            setItemBasicInformation(itemInformation);
            setItemBasicInformationDialogVisible(true);
        }
    }

    function showAnalyticalPlansAuditInformationDialog() {
        showAuditInformationDialog(Entities.AnalyticalPlans);
    }

    function showAuditInformationDialog(entity: Entities) {
        setAuditEntity(entity);
        setAuditRowPointer(props.rawMaterialBatchId);
        setAuditInformationDialogVisible(true);
    }

    function hideAuditInformationDialog() {
        setAuditInformationDialogVisible(false);
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }


    function showAddTechnologyDialog() {
        setAddTechnologyDialogVisible(true);
    }

    function hideAddTechnologyDialog() {
        setAddTechnologyDialogVisible(false);
    }

    function hideEditAnalyticalPlanDialog() {
        setEditAnalyticalPlanDialogVisible(false);
        getProductAnalyticalPlan();
    }

    async function getAllData() {
        await Promise.all([
            getProductAnalyticalPlan(),
            getLookupData()
        ]);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function showToast(message: string, toastType: string) {
        let toastParams: ToastProps = {
            message: message,
            toastType: toastType,
            visible: true
        };

        setToastProps(toastParams);
    }

    function onToastHiding() {
        let toastParams: ToastProps = {
            message: undefined,
            toastType: undefined,
            visible: false
        };

        setToastProps(toastParams);
    }
}
